import {useEffect, useState} from 'react';
import {formatImage} from '../formatos';
import './style.css';

export const ImageComponent = ({ base64img: base64, 
                                 titulo='Imagem', 
                                 class:classe='imagecompoent',
                                 base64: img64=true,
                                 width='100%'
                                 }) => {
    const [cacheBuster, setCacheBuster] = useState(Date.now());
    useEffect(() => {
      setCacheBuster(Date.now());
    }, [base64]);   
    
    if (!base64 || base64 === '' || base64 === 'null' || base64 === 'undefined') {
      return null;
    }  
    
    let imageUrl;
    if(img64){        
      if(base64.substr(0,4)==='data'){
        imageUrl = base64;
      } else {
        imageUrl = `data:image/png;base64,${base64}`;      
      }
    } else {
      const formatted = formatImage(base64);
      if (!formatted) {
        return null;
      }
      imageUrl = `${formatted}?t=${cacheBuster}`;
    }

    return (
      <div className={`container ${classe}`}>
        <h2>{titulo}</h2>
        <img  src={imageUrl} alt="Imagem" width={width} />
      </div>
    );
}; 
